import React from "react"; // Removed useState as it's no longer needed
import { lang } from "../lang"; // lang is kept for potential future use or if notes text needs it

// Component for rendering task notes
function TaskNotes({ notes, useNotes }) {
  // isNotesExpanded state and related logic are removed

  const renderFullNotes = (notesContent) => {
    if (!notesContent) return null;
    const lines = notesContent.split("\n");
    // Always display all lines
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const renderedText = lines.join("\n").replace(urlRegex, (url) => {
      // Sanitize URL before injecting, or ensure URLs are always safe
      // For simplicity here, directly using URL, but be mindful of XSS if URLs can be arbitrary.
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
    return (
      <div
        className="notes-preview" // You might want to rename this class if it's no longer a "preview"
        dangerouslySetInnerHTML={{ __html: renderedText }}
      />
    );
  };

  if (!useNotes || !notes) return null; // Only render if useNotes is true and notes exist

  return (
    <div className="notes-container">
      {renderFullNotes(notes)}
      {/* The expand/collapse button has been removed */}
    </div>
  );
}

export default TaskNotes;
